import React from "react";
import PointOfSaleCore from "../../components/PointOfSale/Core/index";
import SupermarketPreorder from "./SupermarketPreorder";
import useAuthStore from "../../stores/useAuthStore";

const Preorder = () => {
  const tillData = useAuthStore((s) => s.tillData);
  const tillaccess = JSON.parse(tillData?.tillAccess?.userAccessController || "{}");
  const tillLayout = parseInt(tillaccess?.layout === null || undefined ? 1 : tillaccess?.layout);
  return tillaccess.pos === "Y" ? <PointOfSaleCore component={SupermarketPreorder} /> : <h1>Access Denied</h1>;
};

export default Preorder;
